import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { ChainId, type Token } from '../../types';
import { eth } from '../nativeTokens';

export const sepolia: Token[] = [
  eth[ChainId.SEPOLIA],
  {
    chainId: ChainId.SEPOLIA,
    address: '0x66ebd019E86e0af5f228a0439EBB33f045CBe63E',
    decimals: 18,
    symbol: 'XVS',
    iconSrc: iconSrcs.xvs,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x92A2928f5634BEa89A195e7BeCF0f0FEEDAB885b',
    decimals: 8,
    symbol: 'WBTC',
    iconSrc: iconSrcs.wbtc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9',
    decimals: 18,
    symbol: 'WETH',
    iconSrc: iconSrcs.weth,
    tokenWrapped: eth[ChainId.SEPOLIA],
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x8d412FD0bc5d826615065B931171Eed10F5AF266',
    decimals: 6,
    symbol: 'USDT',
    iconSrc: iconSrcs.usdt,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x772d68929655ce7234C8C94256526ddA66Ef641E',
    decimals: 6,
    symbol: 'USDC',
    iconSrc: iconSrcs.usdc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x2c78EF7eab67A6e0C9cAa6f2821929351bdDF3d3',
    decimals: 18,
    symbol: 'CRV',
    iconSrc: iconSrcs.crv,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x36421d873abCa3E2bE6BB3c819C0CF26374F63b6',
    decimals: 18,
    symbol: 'crvUSD',
    iconSrc: iconSrcs.crvUsd,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x9b87ea90fdb55e1a0f17fbeddcf7eb0ac4d50493',
    decimals: 18,
    symbol: 'wstETH',
    iconSrc: iconSrcs.wstEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x3b8b6E96e57f0d1cD366AaCf4CcC68413aF308D0',
    decimals: 18,
    symbol: 'weETH',
    iconSrc: iconSrcs.weEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x78b292069da1661b7C12B6E766cB506C220b987a',
    decimals: 18,
    symbol: 'TUSD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x75236711d42D0f7Ba91E03fdCe0C9377F5b76c07',
    decimals: 18,
    symbol: 'DAI',
    iconSrc: iconSrcs.dai,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x10630d59848547c9F59538E2d8963D63B912C075',
    decimals: 18,
    symbol: 'FRAX',
    iconSrc: iconSrcs.frax,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xd85FfECdB4287587BC53c1934D548bF7480F11C4',
    decimals: 18,
    symbol: 'sFRAX',
    iconSrc: iconSrcs.sFrax,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x56107201d3e4b7Db92dEa0Edb9e0454346AEb8B5',
    decimals: 18,
    symbol: 'PT-weETH-DEC24',
    iconSrc: iconSrcs.ptWeeth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xfA0614E5C803E15070d31f7C38d2d430EBe68E47',
    decimals: 18,
    symbol: 'rsETH',
    iconSrc: iconSrcs.rsEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x14AECeEc177085fd09EA07348B4E1F7Fcc030fA1',
    decimals: 18,
    symbol: 'sfrxETH',
    iconSrc: iconSrcs.sfrxEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xB8eb706b85Ae7355c9FE4371a499F50f3484809c',
    decimals: 18,
    symbol: 'ezETH',
    iconSrc: iconSrcs.ezEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xE233527306c2fa1E159e251a2E5893334505A5E0',
    decimals: 18,
    symbol: 'weETHs',
    iconSrc: iconSrcs.weeths,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x6D9f78b57AEeB0543a3c3B32Cc038bFB14a4bA68',
    decimals: 18,
    symbol: 'pufETH',
    iconSrc: iconSrcs.pufEth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xf140594470Bff436aE82F2116ab8a438671C6e83',
    decimals: 18,
    symbol: 'EIGEN',
    iconSrc: iconSrcs.eigen,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xd48392CCf3fe028023D0783E570DFc71996859d7',
    decimals: 8,
    symbol: 'eBTC',
    iconSrc: iconSrcs.eBtc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x37798CaB3Adde2F4064afBc1C7F9bbBc6A826375',
    decimals: 8,
    symbol: 'LBTC',
    iconSrc: iconSrcs.lbtc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xA3A3e5ecEA56940a4Ae32d0927bfd8821DdA848A',
    decimals: 18,
    symbol: 'sUSDe',
    iconSrc: iconSrcs.sUsdE,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x74671106a04496199994787B6BcB064d08afbCCf',
    decimals: 18,
    symbol: 'PT-USDe-MAR25',
    iconSrc: iconSrcs.ptUsdE,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x3EBa2Aa29eC2498c2124523634324d4ce89c8579',
    decimals: 18,
    symbol: 'PT-sUSDE-MAR25',
    iconSrc: iconSrcs.ptSUsdE,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xE9E34fd81982438E96Bd945f5810F910e35F0165',
    decimals: 18,
    symbol: 'sUSDS',
    iconSrc: iconSrcs.sUsds,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xfB287f9A45E54df6AADad95C6F37b1471e744762',
    decimals: 18,
    symbol: 'USDS',
    iconSrc: iconSrcs.usds,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xa18a6F0F51ddA0BAE3f2368bEE4b1542f6BE66C0',
    decimals: 18,
    symbol: 'BAL',
    iconSrc: iconSrcs.bal,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x9fE6052B9534F134171F567dAC9c9B22556c1DDb',
    decimals: 6,
    symbol: 'yvUSDC-1',
    iconSrc: iconSrcs.yvusdc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x5cBA66C5415E56CC0Ace55148ffC63f61327478B',
    decimals: 6,
    symbol: 'yvUSDT-1',
    iconSrc: iconSrcs.yvusdt,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0xC6A0e98B8D9E9F1160E9cE1f2E0172F41FB06BC2',
    decimals: 18,
    symbol: 'yvUSDS-1',
    iconSrc: iconSrcs.yvusds,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x99AD7ecf9b1C5aC2A11BB00D7D8a7C54fCd41517',
    decimals: 18,
    symbol: 'yvWETH-1',
    iconSrc: iconSrcs.yvweth,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x5B377e8d43D7D11978A83D7F055Dce30daf385AF',
    decimals: 18,
    symbol: 'tBTC',
    iconSrc: iconSrcs.tBtc,
  },
  {
    chainId: ChainId.SEPOLIA,
    address: '0x8bAe3E12870a002A0D4b6Eb0F0CBf91b29d9806F',
    decimals: 18,
    symbol: 'USDe',
    iconSrc: iconSrcs.usde,
  },
];
